"use strict";
window.APP = window.APP || {};
APP.SelectBrandView = Backbone.View.extend({

	template: _.template($('#screen2Template').html()),

  // populate the html to the dom
  render: function () {
    this.$el.html(
    	this.template({})
    );
    return this;
  }
});